"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolDef = void 0;
exports.handle = handle;
const dist_1 = require("../../../fs/dist");
exports.toolDef = {
    name: 'loom_get_context_prefs',
    description: 'Read the persisted sidebar CONTEXT overrides for a target doc from .loom/context-prefs.json. Returns { targetId, entry: { include, exclude } } (empty arrays when none are set).',
    inputSchema: {
        type: 'object',
        properties: {
            targetId: { type: 'string', description: 'Target document id' },
        },
        required: ['targetId'],
    },
};
async function handle(root, args) {
    const targetId = args['targetId'];
    if (!targetId)
        throw new Error('targetId is required');
    const entry = await (0, dist_1.readContextPrefsEntry)(root, targetId);
    return { content: [{ type: 'text', text: JSON.stringify({ targetId, entry }) }] };
}
